<mat-dialog-content>
  <p class="title">{{ 'login.logout_title' | translate }}</p>
  <p>{{ 'login.logout_subtitle' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <bdeo-button type="danger" [text]="'Cancelar'" (click)="onNoClick()" />
  <bdeo-button type="primary" [text]="'Aceptar'" (click)="onYesClick()" [icon]="loading ? 'loading-circle' : ''" [disabled]="loading" />
</mat-dialog-actions>
